export default __webpack_public_path__ + "static/media/manOnTable.9ab086d9.svg";